var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1038",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1038",
    transform: "translate(-890 -827)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_122",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 122",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(890 827)",
    fill: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_123",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 123",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(901 832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_1240",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 1240",
    width: 3,
    height: 9,
    transform: "translate(901 837)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDark);
export default __webpack_public_path__ + "static/media/i_dark.6c7a29f32cace41cd964324fbf1871c0.svg";
export { ForwardRef as ReactComponent };